import { defineMessages } from "react-intl"

export default defineMessages({
  didntReceiveCode: {
    defaultMessage: "Didn't receive your code?",
    id: "src.components.WebAppPortal.VerifyCustomer.didntReceiveCode",
  },
  next: {
    defaultMessage: "Next",
    id: "src.components.WebAppPortal.VerifyCustomer.next",
  },
  nextCapital: {
    defaultMessage: "NEXT",
    id: "src.components.WebAppPortal.VerifyCustomer.nextCapital",
  },
  otp: {
    defaultMessage: "OTP",
    id: "src.components.WebAppPortal.VerifyCustomer.otp",
  },
  phoneNumber: {
    defaultMessage: "Phone Number",
    id: "src.components.WebAppPortal.VerifyCustomer.phoneNumber",
  },
  phoneNumberRequired: {
    defaultMessage: "Phone Number required",
    id: "src.components.WebAppPortal.VerifyCustomer.phoneNumberRequired",
  },
  resendCode: {
    defaultMessage: "RESEND CODE",
    id: "src.components.WebAppPortal.VerifyCustomer.resendCode",
  },
  verificationMessage: {
    defaultMessage: "We've sent a verification code via {communication} to:",
    id: "src.components.WebAppPortal.VerifyCustomer.verificationMessage",
  },
})
